import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FormField, PrimaryButton, SecondaryButton, OrSeparater, LogInCard, ErrorMessage, NoticeMessage, TurnBackgroundBlackComponent, LogInContainer, LogInCardTitle, LogInCardBody, LogInForm, ForgotPasswordLink, PreAuthPageContainer, SignUpTertiary } from "../../../user_portal/preauth_portal/components/CommonComponents"
import { ResearcherContext } from "../../ResearcherContext";
import { PurpleCheckEmailModal } from "../components/common_components/PurpleModals.jsx";


// API Calls
import SessionAPI from "../api/api_calls/sessionAPI.js"

function SignIn(props) {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [notice, setNotice] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);

    //Format Verify Email Modal State
    const [emailModalIsOpen, setEmailModalIsOpen] = useState(false);
    const toggleModal = () => {
        setEmailModalIsOpen(!emailModalIsOpen);
    }



    useEffect(() => {
        if (location.state) {
            if (location.state.notice) {
                const tempNotice = location.state.notice || "";
                setNotice(tempNotice)
            }
            if (location.state.showEmailVerificationModal) {
                toggleModal();
            }
        }
    }, []);

    //Update state on input change
    function onChange(event) {
        switch (event.target.name) {
            case 'email':
                setEmail(event.target.value)
            case 'password':
                setPassword(event.target.value)
        }
    }


    // The log in function called on submit
    function onSubmit(event) {
        event.preventDefault();

        if (email.length == 0 || password.length == 0) { return; }


        const signInResearcher = async () => {
            const response = await SessionAPI.create(email, password, navigate);
            const data = response.data

            if (response.success) {
                refreshResearcher();
                navigate("/dashboard")
            } else {
                // Some errors want a notice instead of an error.
                if (response.reason && response.reason == "unconfirmed") {
                    setError("You have not confirmed your email. Please check your email for a confirmation link.")
                } else {
                    // sets the error message to display to user
                    setError(response.error);
                }
            }

        }

        signInResearcher();
    }


    return (
        <PreAuthPageContainer>
            <ErrorMessage errors={error} />
            <NoticeMessage notices={notice} />
            <TurnBackgroundBlackComponent />
            <LogInContainer >
                <LogInCard>
                    <LogInCardTitle title="Researcher Login" />
                    <LogInCardBody >
                        <LogInForm onSubmit={(event) => onSubmit(event)} >
                            <FormField label="Email" name="email" id="userEmail" placeholder="Email" type="email" autoComplete="username" onChange={onChange} marginClass="mb-4" />
                            <FormField label="Password" name="password" id="userPassword" placeholder="Password" autoComplete="current-password" type="password" onChange={onChange} marginClass="mb-2" />
                            <ForgotPasswordLink />
                            <div className="mt-32">
                                <PrimaryButton text="Login" buttonType="submit" marginClass="mb-3" />
                            </div>
                            <div className="mobile-note">
                                Note: This portal is optimized for desktop screens. You may encounter issues on mobile.
                            </div>
                        </LogInForm>
                    </LogInCardBody>
                </LogInCard>
                <div className="flex-column align-items-center pcx-30 my-32px w-100">
                    <div className="sign-up-tertiary">
                        Don't have an account? <Link className="secondary-link" to={{ pathname: "/signup" }}>Sign Up</Link>
                    </div>
                </div>
                {emailModalIsOpen && <PurpleCheckEmailModal isOpen={emailModalIsOpen} toggleModal={toggleModal} />}
            </LogInContainer>
        </PreAuthPageContainer>
    );

}


//export default SignIn;
export default SignIn